import React, { JSX } from 'react';
import { Alert, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { DevicesOther as DevicesIcon } from '@mui/icons-material';
import { MFAData } from 'types/types';

export const TrustedDevicesManager = (): JSX.Element => {
  const devices: MFAData[] = [];

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          <DevicesIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Trusted Devices
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Manage devices that you&apos;ve marked as trusted. You won&apos;t need to verify your
          identity when signing in from these devices.
        </Typography>
        {devices.length === 0 ? (
          <Alert severity="info">
            No trusted devices yet. When you log in from a new device and choose to remember it, it
            will appear here.
          </Alert>
        ) : (
          <Grid container spacing={2}>
            {devices.map((device, index) => (
              <Grid key={index} size={{ xs: 12, md: 6 }}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="subtitle1">{device.deviceName}</Typography>
                    <Button
                      size="small"
                      color="error"
                      sx={{ mt: 1 }}
                      onClick={() => console.log('Remove device')}
                    >
                      Remove
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};
